import React, { useMemo, useState } from "react";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { useSearchParams } from "react-router-dom";

export default function FunctionsTable({ data, rows }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [paginationModel, setPaginationModel] = useState({
    page: Number(searchParams.get("page") ?? 1) - 1,
    pageSize: Number(searchParams.get("page_size") ?? 50),
  });

  const handlePaginationModelChange = newPaginationModel => {
    searchParams.set("page", newPaginationModel.page + 1);
    searchParams.set("page_size", newPaginationModel.pageSize);

    setSearchParams(searchParams);
    setPaginationModel(newPaginationModel);
  };

  const columns = useMemo(
    () => [
      {
        headerName: "Filial",
        field: "rjFilial",
        flex: 1,
        renderCell: params => params.row?.RJ_FILIAL,
      },
      {
        headerName: "Função",
        field: "rjFuncao",
        flex: 1,
        renderCell: params => params.row?.RJ_FUNCAO,
      },
      {
        headerName: "Descrição",
        field: "rjDesc",
        flex: 1,
        renderCell: params => params.row?.RJ_DESC,
      },
      {
        headerName: "CBO",
        field: "rjCodCbo",
        flex: 1,
        renderCell: params => params.row?.RJ_CODCBO,
      },
      {
        field: "actions",
        type: "actions",
        headerName: "Ações",
        width: 70,
        getActions: params => [
          <GridActionsCellItem
            onClick={() => {
              searchParams.set("function_id", params.row.RJ_FUNCAO);
              setSearchParams(searchParams);
            }}
            label="Editar"
            showInMenu
          />,
        ],
      },
    ],
    [searchParams, setSearchParams],
  );

  return (
    <DataGrid
      rows={data}
      columns={columns}
      getRowId={row => row.R_E_C_N_O_}
      sx={{ flex: 1, border: "none" }}
      disableColumnMenu
      disableColumnFilter
      disableColumnSelector
      disableRowSelectionOnClick
      rowCount={rows}
      paginationMode="server"
      paginationModel={paginationModel}
      onPaginationModelChange={handlePaginationModelChange}
    />
  );
}
